export default __webpack_public_path__ + "static/media/1.33dce916.png";